import { Box, Grid, Toolbar, Link } from '@mui/material'
import { string } from 'prop-types'
import NextImageWrapper from '../../images/NextImageWrapper'

export default function PartnershipBarMobile({
  testId = 'partnership-bar-mobile',
}) {
  return (
    <Toolbar
      disableGutters
      sx={{
        height: '44px !important',
        minHeight: '44px !important',
        position: 'relative',
      }}
      data-testid={testId}
    >
      <Grid container alignItems='center'>
        <Grid mobileCutoff={10} container justifyContent={'center'}>
          <Box mr={1.75} tabIndex='0'>
            <Link
              href='/'
              sx={{
                cursor: 'pointer',
                position: 'static',
                padding: '12px',
              }}
            >
              <NextImageWrapper
                testId={`${testId}-ascd-logo`}
                priority
                src={'/images/greenLogo.svg'}
                alt='ASCD green logo'
                width={61}
                height={20}
              />
            </Link>
            <Link
              href='https://iste.org/'
              sx={{
                cursor: 'pointer',
                position: 'static',
                padding: '12px',
              }}
            >
              <NextImageWrapper
                testId={`${testId}-iste-logo`}
                priority
                src={'/images/greenIsteLogo.svg'}
                alt='ISTE green logo'
                width={36}
                height={20}
              />
            </Link>
            <Link
              href='https://www.edsurge.com/'
              sx={{
                cursor: 'pointer',
                position: 'static',
                padding: '12px',
              }}
            >
              <NextImageWrapper
                testId={`${testId}-edsurge-logo`}
                priority
                src={'/images/greenEdsurgeLogo.svg'}
                alt='EdSurge green logo'
                width={60}
                height={20}
              />
            </Link>
          </Box>
        </Grid>
      </Grid>
    </Toolbar>
  )
}

PartnershipBarMobile.propTypes = {
  testId: string,
}
